import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './assets/iconfont/iconfont.css'
import VueI18n from "vue-i18n"
import {
	getLangLable
} from './service/index'
Vue.use(ElementUI);
Vue.use(VueI18n)

let langInfo = {
	de: {},
	zh: {},
	en: {},
	es: {}
}
const i18n = new VueI18n({
	locale: sessionStorage.getItem('language_name') || 'zh',
	messages: {
		// require('../src/assets/lang/zh.json')
		'zh': langInfo.zh,
		'en': langInfo.en,
		'de': langInfo.de,
		'es': langInfo.es
	}
});
getLangLable().then(res => {
	if (res.code === 200) {
		let data = res.data
		i18n.setLocaleMessage("zh", data.zh);
		i18n.setLocaleMessage("en", data.en);
		i18n.setLocaleMessage("de", data.de);
		i18n.setLocaleMessage("es", data.es);
	}
})
Vue.config.productionTip = false

let arrEntities = {
	'lt': '<',
	'gt': '>',
	'nbsp': ' ',
	'amp': '&',
	'quot': '"'
};
Vue.prototype.strReplace = function(str) {
	return str.replace(/&(lt|gt|nbsp|amp|quot);/g, function(all, t) {
		return arrEntities[t];
	})
}


new Vue({
	router,
	i18n,
	render: h => h(App)
}).$mount('#app')
